/** League workspace lifecycle helpers (canonical lsc_leagues.status). */

export const LEAGUE_STATUS_ACTIVE = 'active';
export const LEAGUE_STATUS_ARCHIVED = 'archived';

export const ARCHIVE_LEAGUE_CONFIRMATION_COPY =
  'Archiving hides this league from active lists and blocks new imports, syncs, claims, and publishing. Existing matches, members, VOD archive, and audit history are preserved.';

export const ARCHIVED_LEAGUE_BANNER_COPY =
  'This league is archived. New imports, syncs, claims, and publishing are disabled.';

export function isLeagueArchived(status?: string | null): boolean {
  return status === LEAGUE_STATUS_ARCHIVED;
}

export function archiveConfirmationMatches(
  typed: string,
  league: { name?: string; slug?: string }
): boolean {
  const normalized = typed.trim().toLowerCase();
  if (!normalized) return false;
  const name = (league.name || '').trim().toLowerCase();
  const slug = (league.slug || '').trim().toLowerCase();
  return normalized === name || normalized === slug;
}
